module.exports = __webpack_public_path__ + "img/cxxzxqy.3f8c9320.png";